const Data = [
  {
    Thumbnail: "/images/pixel8pro.jpg",
    Price: "91000",
    Brand: "Pixel",
    Camera: "8",
    Battery: "5000",
  },
  {
    Thumbnail: "/images/razr40ultra.jpg",
    Price: "26000",
    Brand: "Motorola",
    Camera: "18",
    Battery: "5600",
  },
  {
    Thumbnail: "/images/s24ultra.jpg",
    Price: "27000",
    Brand: "Samsung",
    Camera: "18",
    Battery: "5700",
  },
  {
    Thumbnail: "/images/nothinphone1.jpg",
    Price: "28000",
    Brand: "Nothing",
    Camera: "20",
    Battery: "5800",
  },
  {
    Thumbnail: "/images/appleiphone12.jpg",
    Price: "30000",
    Brand: "Apple",
    Camera: "20",
    Battery: "5800",
  },
  {
    Thumbnail: "/images/appleiphone13.jpg",
    Price: "32000",
    Brand: "Apple",
    Camera: "22",
    Battery: "5900",
  },
  {
    Thumbnail: "/images/xiaomipocox6pro.jpg",
    Price: "34000",
    Brand: "Xiaomi",
    Camera: "24",
    Battery: "6000",
  },
  {
    Thumbnail: "/images/google-pixel-6-pro-1.jpg",
    Price: "34500",
    Brand: "Google",
    Camera: "25",
    Battery: "6000",
  },
  {
    Thumbnail: "/images/google-pixel7-pro-2.jpg",
    Price: "44000",
    Brand: "Google",
    Camera: "9",
    Battery: "3500",
  },
  {
    Thumbnail: "/images/motorola-edge-40-neo-1.jpg",
    Price: "45500",
    Brand: "Motorola",
    Camera: "9",
    Battery: "3000",
  },
  {
    Thumbnail: "/images/motorola-edge-50-ultra-0.jpg",
    Price: "49500",
    Brand: "Motorola",
    Camera: "9",
    Battery: "4000",
  },
  {
    Thumbnail: "/images/motorola-edge50-pro-1.jpg",
    Price: "36000",
    Brand: "Motorola",
    Camera: "10",
    Battery: "4000",
  },
  {
    Thumbnail: "/images/motorola-moto-g64-1.jpg",
    Price: "39500",
    Brand: "Motorola",
    Camera: "10",
    Battery: "4000",
  },
  {
    Thumbnail: "/images/motorola-moto-g84-1.jpg",
    Price: "51000",
    Brand: "Motorola",
    Camera: "11",
    Battery: "4100",
  },
  {
    Thumbnail: "/images/samsung-galaxy-a15-lte-1.jpg",
    Price: "52500",
    Brand: "Samsung",
    Camera: "12",
    Battery: "4200",
  },
  {
    Thumbnail: "/images/samsung-galaxy-a35-1.jpg",
    Price: "59500",
    Brand: "Samsung",
    Camera: "13",
    Battery: "4300",
  },
  {
    Thumbnail: "/images/samsung-galaxy-a55-1.jpg",
    Price: "62500",
    Brand: "Samsung",
    Camera: "14",
    Battery: "4400",
  },
  {
    Thumbnail: "/images/samsung-galaxy-c55-1.jpg",
    Price: "64000",
    Brand: "Samsung",
    Camera: "15",
    Battery: "4500",
  },
  {
    Thumbnail: "/images/nothing-phone2-1_.jpg",
    Price: "80000",
    Brand: "Nothing",
    Camera: "5",
    Battery: "4600",
  },
  {
    Thumbnail: "/images/oneplus-12r-1.jpg",
    Price: "95000",
    Brand: "OnePlus",
    Camera: "6",
    Battery: "4700",
  },
  {
    Thumbnail: "/images/oneplus-nord-ce4-11.jpg",
    Price: "75000",
    Brand: "OnePlus",
    Camera: "7",
    Battery: "4800",
  },
  {
    Thumbnail: "/images/asuszenfone10.jpg",
    Price: "15000",
    Brand: "Asus",
    Camera: "26",
    Battery: "5100",
  },
  {
    Thumbnail: "/images/iphone15promax.jpg",
    Price: "20000",
    Brand: "Apple",
    Camera: "26",
    Battery: "5200",
  },
  {
    Thumbnail: "/images/nothingphone2a.jpg",
    Price: "22000",
    Brand: "Nothing",
    Camera: "27",
    Battery: "5300",
  },
  {
    Thumbnail: "/images/oneplus12.jpg",
    Price: "24500",
    Brand: "OnePlus",
    Camera: "28",
    Battery: "5400",
  },
  {
    Thumbnail: "/images/oneplusopen.jpg",
    Price: "23000",
    Brand: "OnePlus",
    Camera: "30",
    Battery: "5500",
  },
  {
    Thumbnail: "/images/pixel7.jpg",
    Price: "21000",
    Brand: "Pixel",
    Camera: "30",
    Battery: "5500",
  },
];
export default Data;
